// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../components/icons/PlusJakartaSans-VariableFont_wght.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
    font-family: 'PlusJakartaSans';
    /* Choose a name for your font */
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
    /* Additional font properties can be specified, such as font-weight, font-style, etc. */
}

.each-report-container {
    height: 32px;
    width: 94px;
    position: relative;
    margin-top: 12px;
    display:flex;
    justify-content:flex-start;
    align-items:center;
}

.rectangle {
    height: 32px;
    left: -3px;
    position: fixed;
    top: 0;
    width: 100px;
    position: absolute;
}

.tag-typography {
    position: absolute;
    bottom: 2;
    /* margin-bottom:2px; */
    left: -1;
    padding: 5px 2px 5px 5px;
    font-size: 16px;
    color: #FFF;
    font-family: 'PlusJakartaSans';
    font-style: normal;
    font-weight: 500;
    line-height: "20px";
}

.id-typography {
    font-family: PlusJakartaSans;
    font-size: 20px;
    font-style: normal;
    font-weight: bold;
    line-height: 32px;
    margin-left: 2px;
    font-weight: bold;
}

.report-card-edit-right-container {
    padding-left:0 !important;
    width: 100%;

}

.report-card-right-header {
    width: 100%;
    margin-left: 11px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: "small";
}
.report-edit-popup-container {
    height: 100vh; /* Set height to 100% of the viewport height */
    overflow-y: hidden; /* Hide the vertical scroll */
z-index: 999;
}

.report-edit-popup-status-container-status{
    margin-top: 40px;
}
.report-edit-popup-status-input{
    width: 300px;
    padding: 0;
    margin-left: 7px;
}
.report-edit-status-input-in-box{
    height:30px;
    padding:4px 8px;
    border-radius:2px;
    width:auto;
}
.report-edit-popup-status-in-box-text {
    font-size: 14px;
    font-style: normal;
    font-weight: 800;
    line-height: 20px;
}
.report-edit-popup-status-label {
    margin: 10px;
    margin-top: 12px;
    font-family: PlusJakartaSans;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 20px;
}
/* .report-edit-popup-assign-input-in{
    width: 30px;
    height:30px;
    margin-right:10px;
} */
.report-edit-popup-footer {
    position: fixed;
    bottom: 0;
    width: 100%; /* Make the footer full-width */
    background-color: white; /* Adjust as needed */
    padding: 16px; /* Adjust as needed */
    border-top: 1px solid #ccc; /* Optional: Add a border between content and footer */
  }
.report-comments-popup-container {
    height: 100%;
}
.report-comments-popup-in-center{
    width:100%;
    height: 100%;
    display:flex;
    align-items:center;
    justify-content:center;
    flex-direction:column;
}

.report-comments-popup-title-typography {
    margin-left: "14px";
    font-size: "19px";
    font-style: "normal";
    font-weight: 500;
    line-height: "24px";
    margin: "16px";
    justify-content: "center";
    align-items: "center";
}
.comments-body-container{
    height: calc(100% - 222px);
    margin-bottom: 34px;
    flex-basis: calc(47.33% ),
}
.report-comment-popup-footer {
    width: 100%;
    height: 50px;
}

.report-comment-popup-footer-in {
    width: 100%;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
    overflow: 0;
}
.report-card-right-lower-container{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    margin: 8px; 
    margin-top: 4px;
}
.report-card-right-center {
    display: flex;
    margin-top: 20px;
    margin-left: 6px;
    margin-right: 10px;
    flex-direction: row;
    justify-content: space-between;
    width: 100%;
}
.css-i9fmh8-MuiBackdrop-root-MuiModal-backdrop {
    height:100%;
}
.report-edit-popup-title-container{
    display: flex;
    background-color: #0D0D30;
    color:white;
    justify-content: flex-start;
    align-content: flex-start;
    height:55px;
}
@media (max-width: 1652px) and (min-width: 720px) {
    .id-typography {
        font-size: medium;
        font-weight: bold;
    }

    .report-edit-popup-footer {
        margin-top: 67%;
    }

    .report-comment-popup-footer-in {
        margin-top: 0%;
    }

    .report-card-edit-button-container {
        justify-content: center;
    }
}
@media (max-height: 600px) and (min-height: 300px) {
    .id-typography {
        font-size: medium;
        font-weight: bold;
    }

    .report-edit-popup-footer {
        margin-top: 0;
    }

    .report-comment-popup-footer-in {
        margin-top: 0%;
    }

    .report-card-edit-button-container {
        justify-content: center;
    }
    .report-comments-popup-in-center{
        width:100%;
        height: 50%;
        display:flex;
        align-items:center;
        justify-content:center;
        flex-direction:column;
    }
    .comments-body-container{
        height: calc(100% - 222px);
    }
}
`, "",{"version":3,"sources":["webpack://./src/pages/report/components/ReportCard.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,+DAA8F;IAC9F,uFAAuF;AAC3F;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,YAAY;IACZ,0BAA0B;IAC1B,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,eAAe;IACf,MAAM;IACN,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,uBAAuB;IACvB,QAAQ;IACR,wBAAwB;IACxB,eAAe;IACf,WAAW;IACX,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;IAC5B,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,WAAW;;AAEf;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;AACA;IACI,aAAa,EAAE,8CAA8C;IAC7D,kBAAkB,EAAE,6BAA6B;AACrD,YAAY;AACZ;;AAEA;IACI,gBAAgB;AACpB;AACA;IACI,YAAY;IACZ,UAAU;IACV,gBAAgB;AACpB;AACA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,UAAU;AACd;AACA;IACI,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,4BAA4B;IAC5B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;AACA;;;;GAIG;AACH;IACI,eAAe;IACf,SAAS;IACT,WAAW,EAAE,+BAA+B;IAC5C,uBAAuB,EAAE,qBAAqB;IAC9C,aAAa,EAAE,qBAAqB;IACpC,0BAA0B,EAAE,sDAAsD;EACpF;AACF;IACI,YAAY;AAChB;AACA;IACI,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,oBAAoB;IACpB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;AACA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB;AACJ;AACA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,uCAAuC;IACvC,WAAW;AACf;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,uBAAuB;IACvB,WAAW;IACX,eAAe;AACnB;AACA;IACI,aAAa;IACb,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;IAC9B,WAAW;AACf;AACA;IACI,WAAW;AACf;AACA;IACI,aAAa;IACb,yBAAyB;IACzB,WAAW;IACX,2BAA2B;IAC3B,yBAAyB;IACzB,WAAW;AACf;AACA;IACI;QACI,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,uBAAuB;IAC3B;AACJ;AACA;IACI;QACI,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,uBAAuB;IAC3B;IACA;QACI,UAAU;QACV,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,sBAAsB;QACtB,qBAAqB;IACzB;IACA;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":["@font-face {\r\n    font-family: 'PlusJakartaSans';\r\n    /* Choose a name for your font */\r\n    src: url('../../../components/icons/PlusJakartaSans-VariableFont_wght.ttf') format('truetype');\r\n    /* Additional font properties can be specified, such as font-weight, font-style, etc. */\r\n}\r\n\r\n.each-report-container {\r\n    height: 32px;\r\n    width: 94px;\r\n    position: relative;\r\n    margin-top: 12px;\r\n    display:flex;\r\n    justify-content:flex-start;\r\n    align-items:center;\r\n}\r\n\r\n.rectangle {\r\n    height: 32px;\r\n    left: -3px;\r\n    position: fixed;\r\n    top: 0;\r\n    width: 100px;\r\n    position: absolute;\r\n}\r\n\r\n.tag-typography {\r\n    position: absolute;\r\n    bottom: 2;\r\n    /* margin-bottom:2px; */\r\n    left: -1;\r\n    padding: 5px 2px 5px 5px;\r\n    font-size: 16px;\r\n    color: #FFF;\r\n    font-family: 'PlusJakartaSans';\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    line-height: \"20px\";\r\n}\r\n\r\n.id-typography {\r\n    font-family: PlusJakartaSans;\r\n    font-size: 20px;\r\n    font-style: normal;\r\n    font-weight: bold;\r\n    line-height: 32px;\r\n    margin-left: 2px;\r\n    font-weight: bold;\r\n}\r\n\r\n.report-card-edit-right-container {\r\n    padding-left:0 !important;\r\n    width: 100%;\r\n\r\n}\r\n\r\n.report-card-right-header {\r\n    width: 100%;\r\n    margin-left: 11px;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    font-size: \"small\";\r\n}\r\n.report-edit-popup-container {\r\n    height: 100vh; /* Set height to 100% of the viewport height */\r\n    overflow-y: hidden; /* Hide the vertical scroll */\r\nz-index: 999;\r\n}\r\n\r\n.report-edit-popup-status-container-status{\r\n    margin-top: 40px;\r\n}\r\n.report-edit-popup-status-input{\r\n    width: 300px;\r\n    padding: 0;\r\n    margin-left: 7px;\r\n}\r\n.report-edit-status-input-in-box{\r\n    height:30px;\r\n    padding:4px 8px;\r\n    border-radius:2px;\r\n    width:auto;\r\n}\r\n.report-edit-popup-status-in-box-text {\r\n    font-size: 14px;\r\n    font-style: normal;\r\n    font-weight: 800;\r\n    line-height: 20px;\r\n}\r\n.report-edit-popup-status-label {\r\n    margin: 10px;\r\n    margin-top: 12px;\r\n    font-family: PlusJakartaSans;\r\n    font-size: 14px;\r\n    font-style: normal;\r\n    font-weight: 500;\r\n    line-height: 20px;\r\n}\r\n/* .report-edit-popup-assign-input-in{\r\n    width: 30px;\r\n    height:30px;\r\n    margin-right:10px;\r\n} */\r\n.report-edit-popup-footer {\r\n    position: fixed;\r\n    bottom: 0;\r\n    width: 100%; /* Make the footer full-width */\r\n    background-color: white; /* Adjust as needed */\r\n    padding: 16px; /* Adjust as needed */\r\n    border-top: 1px solid #ccc; /* Optional: Add a border between content and footer */\r\n  }\r\n.report-comments-popup-container {\r\n    height: 100%;\r\n}\r\n.report-comments-popup-in-center{\r\n    width:100%;\r\n    height: 100%;\r\n    display:flex;\r\n    align-items:center;\r\n    justify-content:center;\r\n    flex-direction:column;\r\n}\r\n\r\n.report-comments-popup-title-typography {\r\n    margin-left: \"14px\";\r\n    font-size: \"19px\";\r\n    font-style: \"normal\";\r\n    font-weight: 500;\r\n    line-height: \"24px\";\r\n    margin: \"16px\";\r\n    justify-content: \"center\";\r\n    align-items: \"center\";\r\n}\r\n.comments-body-container{\r\n    height: calc(100% - 222px);\r\n    margin-bottom: 34px;\r\n    flex-basis: calc(47.33% ),\r\n}\r\n.report-comment-popup-footer {\r\n    width: 100%;\r\n    height: 50px;\r\n}\r\n\r\n.report-comment-popup-footer-in {\r\n    width: 100%;\r\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);\r\n    overflow: 0;\r\n}\r\n.report-card-right-lower-container{\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: center;\r\n    align-items: flex-start;\r\n    margin: 8px; \r\n    margin-top: 4px;\r\n}\r\n.report-card-right-center {\r\n    display: flex;\r\n    margin-top: 20px;\r\n    margin-left: 6px;\r\n    margin-right: 10px;\r\n    flex-direction: row;\r\n    justify-content: space-between;\r\n    width: 100%;\r\n}\r\n.css-i9fmh8-MuiBackdrop-root-MuiModal-backdrop {\r\n    height:100%;\r\n}\r\n.report-edit-popup-title-container{\r\n    display: flex;\r\n    background-color: #0D0D30;\r\n    color:white;\r\n    justify-content: flex-start;\r\n    align-content: flex-start;\r\n    height:55px;\r\n}\r\n@media (max-width: 1652px) and (min-width: 720px) {\r\n    .id-typography {\r\n        font-size: medium;\r\n        font-weight: bold;\r\n    }\r\n\r\n    .report-edit-popup-footer {\r\n        margin-top: 67%;\r\n    }\r\n\r\n    .report-comment-popup-footer-in {\r\n        margin-top: 0%;\r\n    }\r\n\r\n    .report-card-edit-button-container {\r\n        justify-content: center;\r\n    }\r\n}\r\n@media (max-height: 600px) and (min-height: 300px) {\r\n    .id-typography {\r\n        font-size: medium;\r\n        font-weight: bold;\r\n    }\r\n\r\n    .report-edit-popup-footer {\r\n        margin-top: 0;\r\n    }\r\n\r\n    .report-comment-popup-footer-in {\r\n        margin-top: 0%;\r\n    }\r\n\r\n    .report-card-edit-button-container {\r\n        justify-content: center;\r\n    }\r\n    .report-comments-popup-in-center{\r\n        width:100%;\r\n        height: 50%;\r\n        display:flex;\r\n        align-items:center;\r\n        justify-content:center;\r\n        flex-direction:column;\r\n    }\r\n    .comments-body-container{\r\n        height: calc(100% - 222px);\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
